module.exports = __webpack_public_path__ + "static/media/nft.1c925b34.png";